import React, { ReactElement } from "react";
import ReturnSalesSummaryReportList from "../../components/Reports/ReturnSalesSummaryReport";
import MainLayout from "../../components/Layouts";

const ReturnSalesSummaryReportPage = (): ReactElement => {
  return (
    <MainLayout>
      <ReturnSalesSummaryReportList />
    </MainLayout>
  );
}; 

export default ReturnSalesSummaryReportPage;
